// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 237 ? "pages" : chunkId) + "." + {"237":"1b213d12","667":"e948ff72"}[chunkId] + ".chunk.css";
};